/**
* 头部菜单
*/
<template>
  <div>
    <el-menu class="el-menu-demo" mode="horizontal" background-color="#ffffff" text-color="#fff"
             active-text-color="#fff">
      <div class="el-fort disflex">
        <div class="logoImg">
          <img class="logo" src="../../static/img/kfpt_index_logo.png">
        </div>
        <div class="el-font disflex">
          <div class="message_button submenu mr24" @click="gotoSystem">
          </div>
<!--          <div class="icon mr24">-->
<!--            <el-button type="text">-->
<!--              <el-badge :is-dot="hasNewData" class="item">-->
<!--                <i class="el-icon-message colorfff"></i>-->
<!--              </el-badge>-->
<!--            </el-button>-->
<!--          </div>-->
          <div class="disflex mr24" @click="changePwd()">
            <el-button type="text">
              <div class="pictureImg"></div>
            </el-button>
            <el-link :underline="false">
              <div>{{userName}}</div>
            </el-link>
          </div>
          <div class="line mr24"></div>
          <div class="exit" @click="exit()">
            <el-button type="text">退出</el-button>
          </div>
        </div>
      </div>
    </el-menu>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               title="修改密码"
               :visible.sync="changePwdDialogVisible"
               width="22%"
               center>
      <div class="passwordForm">
        <div class="tip">字母+数字组合，长度为6-20位字符，请至少包含一个大写字母。</div>
        <el-form label-width="120px" :model="passwordForm" :rules="rules" ref="passwordForm">
          <el-form-item label="" prop="old_pwd">
            <el-input placeholder="请输入原密码" v-model="passwordForm.old_pwd" show-password></el-input>
          </el-form-item>
          <el-form-item label="" prop="new_pwd">
            <el-input placeholder="请输入新密码" v-model="passwordForm.new_pwd" show-password></el-input>
          </el-form-item>
          <el-form-item label="" prop="crm_new_pwd">
            <el-input placeholder="请再次输入新密码" v-model="passwordForm.crm_new_pwd" show-password></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="changePwdDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="sureChangePwd('passwordForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import {loginout,updatePwd} from '../api/userMG'
  import {webConfig} from "../api/basisMG";

  export default {
    name: 'navcon',
    data() {
      var validatePass = (rule, value, callback) => {
        const reg = /^[a-zA-Z0-9]{6,20}$/;
        const regs = /[A-Z]/;
        if (value === '') {
          callback(new Error('请输入密码'));
        } else if (!reg.test(value) || !regs.test(value)) {
          callback(new Error('长度为6-20位字母+数字组合的字符，至少包含一个大写字母。'));
        } else {
          if (this.passwordForm.crm_new_pwd !== '') {
            this.$refs.passwordForm.validateField('crm_new_pwd');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.passwordForm.new_pwd) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        collapsed: true,
        changePwdDialogVisible: false,
        logining: false,
        password: '',
        userName: '',
        tableDataList: [],
        passwordForm: {
          old_pwd: '',
          new_pwd: '',
          crm_new_pwd: ''
        },
        // rules表单验证
        rules: {
          old_pwd: [
            {required: true, message: '请输入原密码', trigger: 'blur'}
          ],
          new_pwd: [
            {validator: validatePass, trigger: 'blur'}
          ],
          crm_new_pwd: [
            {validator: validatePass2, trigger: 'blur'}
          ],
        },
        web_name:'',
        urlPathName:'',
        hasNewData: false,
        isEmpty: true
      }
    },
    // 创建完毕状态(里面是操作)
    created() {
      this.userName = localStorage.getItem('userName')
      this.urlPathName = window.location.pathname;
      // this.getConfig()
    },
    methods: {
      getConfig() {
        this.loading = true
        // webConfig()
        //   .then(res => {
        //     this.web_name = res.content.web_name;
        //     localStorage.setItem('web_name',res.content.web_name)
        //   })
        //   .catch(err => {
        //   })
      },
      //修改密码
      changePwd() {
        this.changePwdDialogVisible = true;
      },
      sureChangePwd(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.loading = true
            updatePwd(this.passwordForm)
              .then(res => {
                this.loading = false
                if (res.success == false) {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                } else {
                  this.$message({
                    type: 'success',
                    message: '修改成功!'
                  })
                  this.$store.commit('logout', 'false')
                  localStorage.setItem('path', '/Document/typeDocument')
                  this.$router.push({path: '/login'})
                }
              })
              .catch(err => {
                this.loading = false
                this.$message.error('网络错误，请稍后再试！')
              })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      loginoutApi() {
        loginout()
          .then(res => {
            if (res.success) {
              //如果请求成功就让他2秒跳转路由
              setTimeout(() => {
                this.$store.commit('logout', 'false')
                localStorage.setItem('path', '/Document/typeDocument')
                localStorage.removeItem('logintoken')
                this.$router.push({path: '/login'})
                this.$store.commit('clear')
                this.$message({
                  type: 'success',
                  message: '已退出登录!'
                })
              }, 1000)
            } else {
              this.$message.error(res.msg)
              this.logining = false
              return false
            }
          })
          .catch(err => {
            // 获取图形验证码
            this.getcode()
            this.logining = false
            this.$message.error('退出失败，请稍后再试！')
          })
      },
      // 退出登录
      exit() {
        this.$confirm('退出登录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.logining = true
            this.loginoutApi()
            // setTimeout(() => {
            //   this.$store.commit('logout', 'false')
            //   this.$router.push({ path: '/login' })
            //   this.$message({
            //     type: 'success',
            //     message: '已退出登录!'
            //   })
            // }, 1000)
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            })
          })
      },
      // 切换显示
      toggle(showtype) {
        this.collapsed = !showtype
        this.$root.Bus.$emit('toggle', this.collapsed)
      },
      // 跳转到系统消息页面
      gotoSystem() {
        localStorage.setItem('path', '/system/systemMessages')
        let tag = {
          url: "/system/systemMessages",
          menuname: "系统消息"
        }
        this.$store.commit('selectMenu', tag)
        this.$router.push({path: '/system/systemMessages'})
        if (this.tableDataList.length) {
          this.isEmpty = false
        }
      },
    }
  }
</script>
  <style scoped>
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    border: none;
  }

  .submenu {
    float: right;
  }

  .buttonimg {
    height: 60px;
    width: 236px;
    background-color: transparent;
    border: none;
  }

  .buttonimg p {
    color: #fff;
    font-size: 20px;
    font-weight: 600;
  }

  .tip {
    font-size: 12px;
    color: #999999;
    margin-bottom: 10px;
  }

  .logo {
    width: 236px;
  }

  /deep/ .passwordForm .el-form-item__content {
    margin-left: 0 !important;
  }

  .el-fort {
    padding: 18px 30px;
  }

  .el-font {
    height: 24px;
  }

  .mr24 {
    margin-right: 24px;
  }

  .disflex {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .logoImg {
    width: 236px;
    height: 24px;
  }

  /deep/ .icon .el-button--text {
    color: #ffffff;
  }

  /deep/ .icon .el-button {
    padding: 0;
    font-size: 20px;
  }

  .line {
    width: 1px;
    height: 20px;
    background: #cccccc;
  }

  .pictureImg {
    width: 24px;
    height: 24px;
    background: pink;
    margin-right: 6px;
  }

  .exit {
    font-size: 14px;
    line-height: 14px;
  }

  /deep/ .exit .el-button--text {
    color: #333333;
  }

  .submenu {
    float: right;
  }

  .message_button {
    height: 60px;
    line-height: 60px;
    margin-right: 30px;
  }

</style>



// WEBPACK FOOTER //
// src/components/navcon.vue